import getStore from '../store/store';
import type { Module } from 'owa-workloads-module';

export default function getCurrentModule(): Module | undefined {
    return getStore().module;
}
